import { Controller } from 'stimulus';

export default class ExploreNavController extends Controller {
  clearEzSearchState = () => {
    sessionStorage.setItem('ezSearchState', '');
  }
}
